// extracted by mini-css-extract-plugin
module.exports = {"searchWrapper":"search-module--search-wrapper--1FiBW","searchlist":"search-module--searchlist--1zRQ3"};